import MenuDivider, { MenuDividerProps } from 'antd/es/menu/MenuDivider';
export default MenuDivider;
